import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseClassic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMouseClassic"><Path d="M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15V11H19V15Z" fill="currentColor"/><Path d="M13 2.07227C16.3922 2.55758 19 5.4736 19 9H13V2.07227Z" fill="currentColor"/><Path d="M11 9H5C5 5.4736 7.6078 2.55758 11 2.07227V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseClassic;
